import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4db113a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "top" }
const _hoisted_2 = { class: "paymentWrapper" }
const _hoisted_3 = { class: "flex items-center mt-8 mb-6 sm:text-sm" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-4 mr-4" }, null, -1))
const _hoisted_5 = {
  href: "",
  class: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddPlayers = _resolveComponent("AddPlayers")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$t("add_players")), 1)
      ]),
      (_ctx.queryData !== '')
        ? (_openBlock(), _createBlock(_component_AddPlayers, {
            key: 0,
            mode: _ctx.mode.CREATION,
            bookingData: _ctx.queryData,
            onSetUpCompleted: _ctx.goToPay
          }, null, 8, ["mode", "bookingData", "onSetUpCompleted"]))
        : _createCommentVNode("", true)
    ])
  ], 512))
}